export class Notification {
  constructor(
    public type: NotificationType,
    public message: string,
    public time?: number,
    public width?: string,
    public noteInterval?: any,
  ) {
    this.width = '100%';
  }
}

export enum NotificationType {
  Success,
  Error,
  Info,
  Warning
}
